<template>
  <div class="buyerShop">
    <el-button type="primary" @click="handleClick" :loading="loading">完成度初始化</el-button>
    <div class="mt20">{{ result }}</div>
  </div>
</template>

<script>
import {
  getVendorList,
} from '../../buyershop/cn/api';
import {
  getVendorAuditDetail,
  updateVendorAsPerfection,
} from './api';

export default {
  data() {
    return {
      loading: false,
      result: '',
      invoiceRequired: false,
    };
  },
  mounted() {
  },
  methods: {
    async handleClick() {
      this.loading = true;
      this.result = '初始化开始';
      let vendorList = [];
      const res = await getVendorList();
      if (res.data && res.data.data) {
        vendorList = res.data.data;
      }
      for (let i = 0; i < vendorList.length; i++) {
        const item = vendorList[i];
        await this.getDetail(item.vendorId, item.vendorName);
      }
      this.loading = false;
      this.result = '初始化完毕';
    },
    async getDetail(vendorId, vendorName) {
      await getVendorAuditDetail({
        vendorId,
      }).then(async (res) => {
        if (res.data && res.data.success && res.data.data) {
          this.invoiceRequired = res.data.data.invoiceRequired;
          res.data.data.vendorExtReqVo.stockChannel = res.data.data.vendorExtReqVo.stockChannel || [];
          res.data.data.saleChannelReqVos = res.data.data.saleChannelReqVos || [];
          res.data.data.vendorId = vendorId;
          res.data.data.vendorName = vendorName;
          this.payeeInfoData2 = (res.data.data.receivePaymentReqVos || []).filter((item) => item.enabled);
          this.vendorContactsInfoData2 = (res.data.data.vendorContacts || []).filter((item) => item.enabled);
          this.retailStoreData2 = (res.data.data.offlineStoreReqVos || []).filter((item) => item.enabled);
          this.ruleForm = res.data.data;

          if (this.ruleForm.vendorConfigurationVo.vendorType != 5) {
            await this.calcCompletionRate();
          }
        }
      });
    },
    async calcCompletionRate() {
      let total = 29;
      let requiredTotal = 14; // 不计算 母公司名 前面的字段
      let fillCount = 0;
      let requiredCount = 0;
      if (this.ruleForm.paymentInfoReqVo.paymentMethod === 'crm_pre_payment') {
        requiredTotal += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentTiming === 'crm_payment_others') {
        total += 1;
        requiredTotal += 1;
      }
      if (!this.invoiceRequired) {
        requiredTotal -= 9;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore !== 1) {
        total -= 2;
      }
      (this.ruleForm.saleChannelReqVos || []).forEach(item => {
        if (item.status) {
          total += 4;
        } else {
          total += 1;
        }
      })
      if (this.ruleForm.vendorExtReqVo.groupName) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.imDefinition) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.mpSalesSatisfaction) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.wholesaleSalesSatisfaction) {
        fillCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentMethod) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.depositAmount) {
        fillCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentMethod === 'crm_pre_payment' && this.ruleForm.paymentInfoReqVo.depositAmount) {
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentTiming) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentTiming === 'crm_payment_others' && this.ruleForm.paymentInfoReqVo.paymentTimingRemark) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentMethodRemark) {
        fillCount += 1;
      }
      // if (this.ruleForm.vendorExtReqVo.drawback || this.ruleForm.vendorExtReqVo.drawback === 0) {
      //   fillCount += 1;
      //   requiredCount += 1;
      // }
      if (this.ruleForm.invoiceReqVo.companyName) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.businessLicenseNumber) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.contactPerson) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.contactEmail) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.contactPhone) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.addressCountryId) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.city) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.postalCode) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.businessLicenseLocation) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.payeeInfoData2.length > 0) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.vendorContactsInfoData2.length > 0) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.quarterVisitCount) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.otherVisitHabit) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore || this.ruleForm.vendorExtReqVo.isOfflineStore === 0) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore === 1 && this.ruleForm.vendorExtReqVo.offlineStoreDesc) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore === 1 && this.retailStoreData2.length > 0) {
        fillCount += 1;
      }
      (this.ruleForm.saleChannelReqVos || []).forEach(item => {
        if (item.status || item.status === 0) {
          fillCount += 1;
        }
        if (item.status && item.sinceAt) {
          fillCount += 1;
        }
        if (item.status && item.saleAmount) {
          fillCount += 1;
        }
        if (item.status && item.percentage) {
          fillCount += 1;
        }
      });
      if (this.ruleForm.vendorExtReqVo.stockChannel.length > 0) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.otherChannel) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.mpProfitExpectation) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.pfProfitExpectation) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.issuesRespond) {
        fillCount += 1;
      }
      this.infoCompletion = Math.floor(fillCount / total * 100) / 100;
      this.requiredFieldCompletion = Math.floor(requiredCount / requiredTotal * 100) / 100;

      await updateVendorAsPerfection({
        vendorId: this.ruleForm.vendorId,
        vendorAsPerfection: this.infoCompletion,
        requiredFieldsVendorAsPerfection: this.requiredFieldCompletion,
      });
      this.result = `${this.ruleForm.vendorName}完成度${this.infoCompletion}，必填字段完成度${this.requiredFieldCompletion}`;
    },
  },
};
</script>

<style lang="less" scoped>
.buyerShop {
  padding: 20px;
}
.mt20 {
  margin-top: 20px;
}
</style>